import { ContentSection } from '@cinch-labs/design-system'
import { StoryblokTableSection } from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import { CookiePolicyTable } from '../cookie-policy-table/cookie-policy-table'

export const TableSection: React.FC<StoryblokTableSection> = ({
  heading,
  description,
  table,
  dontShowTableHeader,
}) => (
  <ContentSection>
    <p>
      <strong>{heading}</strong>
    </p>
    {description && renderWithResolver(description)}
    {table && (
      <CookiePolicyTable
        table={table}
        dontShowTableHeader={dontShowTableHeader}
      />
    )}
  </ContentSection>
)
